exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row[data-v-529d8b9e] {\n  justify-content: center;\n}\n.select-plan-header[data-v-529d8b9e] {\n  margin-bottom: 3rem;\n  text-align: center;\n}", ""]);

// exports
